import React from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {KTCard, KTCardBody, KTIcon} from '../../../_websoft/helpers'
import ProductionAnalyticsModal from './ProductionAnalyticsModal'

const ProductionAnalyticsPage: React.FC = () => {
    const {id} = useParams()
    const navigate = useNavigate()
    const orderId = Number(id)

    return (
        <KTCard>
            <KTCardBody className='py-4'>
                <div className='d-flex justify-content-end mb-6'>
                    <button type='button' className='btn btn-light-primary' onClick={() => navigate('/galanterija/plavi-nalog')}>
                        <KTIcon iconName='arrow-left' className='fs-2' />
                        Nazad
                    </button>
                </div>
                <ProductionAnalyticsModal orderId={orderId} />
            </KTCardBody>
        </KTCard>
    )
}

export default ProductionAnalyticsPage
